import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import axiosInstance from "../../utils/axiosInstance";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { acceptAppointment, completeAppointment, declineAppointment, fetchAppointmentDetails, imageBaseUrl } from "../../constants/ApiConstants";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { linearTopGradient } from "../../constants/colors";
import toast from "react-hot-toast";
import FullPageLoader from "../../components/FullPageLoader";
import AppointmentTimeInfo from "../AppointmentSummary/comps/AppointmentTimeInfo";
import AppointmentOrderSummary from "../AppointmentSummary/comps/AppointmentOrderSummary";
import DoctorDetailHeader from "../../components/DoctorDetailHeader";
import SecondaryButton from "../../components/SecondaryButton";
import Rating from "../../components/Rating";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import PatientAppointmentRequestCard from "../../components/PatientAppointmentRequestCard";
import MyModal from "../../components/MyModal";
import InputField from "../../components/InputField";
import TextAreaField from "../../components/TextAreaField";
import ChatModal from "../../components/ChatModal";

export default function AppointmentDetails() {
  pageTitle("Appointment Details");
  const { appointmentId } = useParams();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.appSlice.userData);
  const doctorData = useSelector((state) => state.appSlice.doctorData);
  const [appointmentData, setAppointmentData] = useState();
  const [loading, setLoading] = useState(false);

  const [acceptAppointmentModalShow, setAcceptAppointmentModalShow] = useState(false);
  const [rejectAppointmentModalShow, setRejectAppointmentModalShow] = useState(false);
  const [completeAppointmentModalShow, setCompleteAppointmentModalShow] = useState(false);
  const [completeAppointmentData, setCompleteAppointmentData] = useState({ completion_otp: "", diagnosed_with: "" });

  const [submitting, setSubmitting] = useState(false);

  const [coupon, setCoupon] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(true);

  useEffect(() => {
    fetchAppointmentDetail();
  }, []);

  const fetchAppointmentDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchAppointmentDetails, {
        appointment_id: appointmentId,
      })
      .then((res) => {
        setAppointmentData(res.data.data);
        if (res.data.data.coupon_title != null) {
          setCoupon({ coupon: res.data.data?.coupon_title });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleMedicalPrescriptionClick = () => {
    navigate(`/add-prescriptions/${appointmentData.id}`);
  };
  const handleCompleteAppointmentClick = () => {
    if (completeAppointmentData.completion_otp === "" || completeAppointmentData.diagnosed_with === "") {
      toast.error("Please fill in all the fields.");
      return;
    }
    setSubmitting(true);

    axiosInstance
      .post(completeAppointment, {
        doctor_id: doctorData?.id,
        appointment_id: appointmentData?.id,
        ...completeAppointmentData,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Appointment has been accepted.");
          setCompleteAppointmentModalShow(false);
          setCompleteAppointmentData({ completion_otp: "", diagnosed_with: "" });
          fetchAppointmentDetail();
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleAcceptAppointment = () => {
    setSubmitting(true);
    axiosInstance
      .post(acceptAppointment, {
        doctor_id: doctorData?.id,
        appointment_id: appointmentData?.id,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Appointment has been accepted.");
          setAcceptAppointmentModalShow(false);
          fetchAppointmentDetail();
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  const handleRejectAppointment = () => {
    setSubmitting(true);
    axiosInstance
      .post(declineAppointment, {
        doctor_id: doctorData?.id,
        appointment_id: appointmentData?.id,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Appointment has been rejected.");
          setRejectAppointmentModalShow(false);
          fetchAppointmentDetail();
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleRescheduleAppointment = () => {
    navigate(`/date-select/${appointmentData.doctor?.id}?appointmentId=${appointmentData.id}`);
  };
  return (
    <Wrapper>
      <Section topMd={20} topLg={20} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading && !appointmentData && <FullPageLoader />}
        {!loading && appointmentData && (
          <div className="content-wrapper">
            <CommonMobileHeader canBack={true} title={appointmentData?.appointment_number} />
            <div className="row mb-2">
              {doctorData ? (
                <PatientAppointmentRequestCard
                  key={appointmentData.id}
                  name={appointmentData.user?.fullname}
                  image={appointmentData.user?.profile_image}
                  dateOfBirth={appointmentData.user?.dob}
                  appointmentDate={appointmentData.date}
                  appointmentTime={appointmentData.time}
                  gender={appointmentData.user?.gender}
                  showView={false}
                />
              ) : (
                <>
                  <strong className="text-black fw-bold m-3">{appointmentData?.appointment_number}</strong>
                  <div className="col-md-6">
                    <DoctorDetailHeader image={appointmentData?.doctor?.image} name={appointmentData?.doctor?.name} designation={appointmentData?.doctor?.designation} degrees={appointmentData?.doctor?.degrees} />
                  </div>
                </>
              )}

              <div className="col-md-6 g-2 px-3">
                <AppointmentTimeInfo date={appointmentData.date} time={appointmentData.time} type={appointmentData.type === 0 ? "Online" : "Clinic"} />
                <AppointmentOrderSummary
                  isApplyCouponVisible={false}
                  coupon={coupon}
                  serviceAmount={appointmentData.service_amount}
                  subtotal={appointmentData.subtotal}
                  payableAmount={appointmentData.payable_amount}
                  taxes={JSON.parse(appointmentData?.order_summary).taxes}
                  totalTaxAmount={appointmentData.total_tax_amount}
                />
                <strong className="fs-normal d-block px-2 fw-normal text-secondary mt-3">Your Problem</strong>
                <span className="py-2 px-3 d-block bg-grey2 fs-md text-grey2 mb-3">{appointmentData.problem}</span>
                {appointmentData?.documents?.length > 0 && (
                  <>
                    <strong className="fs-normal d-block px-2 fw-normal text-secondary mt-3">Attachments</strong>
                    <div className="py-2 px-3 d-block bg-grey2 fs-md text-grey2 mb-3">
                      {appointmentData?.documents.map((document, i) => (
                        <Link key={i} to={`${imageBaseUrl}${document.image}`}>
                          <img className="col-4 p-1 object-fit-contain" src={`${imageBaseUrl}${document.image}`} />
                        </Link>
                      ))}
                      {appointmentData.rating && (
                        <div className="px-2 py-2 bg-grey2">
                          <strong className="text-black fs-normal">Your Review</strong>
                          <Rating ratingNumber={appointmentData?.rating.rating} />
                          <span className="fs-md text-grey2 mt-1">{appointmentData?.rating.comment}</span>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {appointmentData?.status === 0 && userData && (
                  <div>
                    <div className="d-flex gap-2">
                      <button type="button" className="w-100 py-2 m-2 rounded bg-success-surface" onClick={handleRescheduleAppointment}>
                        Reschedule
                      </button>
                      <button type="button" className="w-100 py-2 m-2 rounded bg-danger-surface">
                        Cancel
                      </button>
                    </div>
                  </div>
                )}

                {appointmentData?.status === 0 && doctorData && (
                  <div>
                    <div className="d-flex gap-2">
                      <button type="button" className="w-100 py-2 m-2 rounded bg-danger-surface" onClick={() => setRejectAppointmentModalShow(true)}>
                        Reject
                      </button>
                      <button type="button" className="w-100 py-2 m-2 rounded bg-success-surface" onClick={() => setAcceptAppointmentModalShow(true)}>
                        Accept
                      </button>
                    </div>
                  </div>
                )}

                {appointmentData.status === 1 && userData && (
                  <>
                    <div className="bg-grey2 py-2 px-2 mt-3">
                      <span className="fs-normal text-grey2">
                        Completion OTP : <strong className="text-black fs-normal fw-regular">{appointmentData?.completion_otp}</strong>
                        <p className="white-space wrap fs-sm text-grey2">Please, provide this OTP to doctor when asked. only after you get your services as per the order.</p>
                      </span>
                    </div>
                  </>
                )}

                {appointmentData.status === 1 && doctorData && (
                  <div className="mt-2">
                    <SecondaryButton title={"Message"} />
                    <button type="button" onClick={handleMedicalPrescriptionClick} className="w-100 py-2 rounded bg-grey2 mt-3 fw-medium text-sprimary">
                      Medical Prescription
                    </button>
                    <button type="button" onClick={() => setCompleteAppointmentModalShow(true)} className="w-100 py-2 rounded bg-success-surface mt-3">
                      <strong>Complete Appointment</strong>
                    </button>
                  </div>
                )}
              </div>
            </div>
            {/* Accept Appointment */}
            <MyModal isOpen={acceptAppointmentModalShow} modalTitle={"Accept Appointment"} modalSubtitle={"Do you really want to acceot the appointment?"} onClose={() => setAcceptAppointmentModalShow(false)}>
              <div className="mt-4">
                <SecondaryButton title="Confirm" loading={submitting} onClick={handleAcceptAppointment} />
              </div>
            </MyModal>
            {/* Reject Appointment */}
            <MyModal isOpen={rejectAppointmentModalShow} modalTitle={"Reject Appointment"} modalSubtitle={"Do you really want to reject the appointment?"} onClose={() => setRejectAppointmentModalShow(false)}>
              <div className="mt-4">
                <SecondaryButton title="Confirm" loading={submitting} onClick={handleRejectAppointment} />
              </div>
            </MyModal>

            {/* Complete Appointment */}
            <MyModal
              isOpen={completeAppointmentModalShow}
              modalTitle={"Summary"}
              onClose={() => {
                setCompleteAppointmentModalShow(false);
                setCompleteAppointmentData({ diagnosed_with: "", completion_otp: "" });
              }}
            >
              <TextAreaField label="Diagnosed With" value={completeAppointmentData.diagnosed_with} onChange={(e) => setCompleteAppointmentData({ ...completeAppointmentData, diagnosed_with: e.target.value })} />
              <InputField label="Completion OTP" inputType={"number"} value={completeAppointmentData.completion_otp} onChange={(e) => setCompleteAppointmentData({ ...completeAppointmentData, completion_otp: e.target.value })} />
              <div className="mt-5"></div>
              <SecondaryButton title="Confirm" loading={submitting} onClick={handleCompleteAppointmentClick} />
            </MyModal>
          </div>
        )}
        {appointmentData && <ChatModal isOpen={isChatOpen} appointment={appointmentData} onClose={setIsChatOpen} />}
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
